import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { Checkbox } from 'syf-component-library/ui/atoms';
import Grid from 'syf-component-library/ui/patterns/Grid/Grid';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import { Stack } from 'syf-component-library/ui/spacing';
import Body from 'syf-component-library/ui/typography/Body';
import H5 from 'syf-component-library/ui/typography/H5';
import { DATA_TYPE } from '../../../../const/analytics';
import { FAR_CHECK } from '../../../../const/iconProps';
import { colors } from '../../../../defaultTheme';
import { isInstallmentLoan } from '../../../../helpers/productTypeHelpers';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import { t } from '../../../../strings/i18n';
import AutopayLegal from '../../../../ui/atoms/AutopayLegal';
const Heading = styled(H5) `
  font-size: ${fontSizes.root}px;
  font-weight: ${fontWeights.bold};
`;
const AutopayDescription = styled(Body) `
  font-size: ${fontSizes.root}px;
  color: ${colors.black};
  margin-bottom: ${spacing.base}px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const getDescriptionText = ({ type: productType }) => {
    if (isInstallmentLoan(productType)) {
        return t('autopay.manageAutopayAmountAndPaymentMethod');
    }
    return t('autopay.autopayMinimumPaymentText');
};
const OneClickAutopayBanner = ({ isChecked, product, setIsChecked }) => {
    const [apiMachine] = useApiMachine();
    const { accountSummaryQueryResult: { data: { billing } }, featureFlags } = apiMachine.context;
    return (_jsxs(_Fragment, { children: [_jsx(Stack, {}), _jsx(MessageBox, Object.assign({ "data-cy": "autopay-banner" }, { children: _jsxs(Grid, { children: [_jsxs(Grid, Object.assign({ item: true }, { children: [_jsx(Heading, Object.assign({ "data-cy": "one-click-autopay-banner-heading", weight: "bold" }, { children: t('autopay.oneClickAutopayBannerHeading') })), _jsx(Stack, { size: "small" })] })), _jsx(Grid, Object.assign({ container: true, direction: "column" }, { children: _jsx(Grid, Object.assign({ alignItems: "flex-start", item: true, xs: 12 }, { children: _jsx(Checkbox, Object.assign({ dataCy: "one-click-autopay-checkbox", dataObject: isChecked ? 'oneclick checked' : 'oneclick unchecked', dataReason: "check enroll in autopay", dataType: DATA_TYPE.MAKE_A_PAYMENT, icon: isChecked ? (_jsx(FontAwesomeIcon, { color: "white", icon: FAR_CHECK })) : null, id: "enroll-autopay", isChecked: isChecked, padding: "5px 0px 0px 0px", onChange: () => setIsChecked(!isChecked) }, { children: _jsxs("div", { children: [_jsx(AutopayDescription, Object.assign({ "data-cy": "one-click-autopay-banner-description" }, { children: t('autopay.oneClickAutopayBannerDescription') })), isChecked && (_jsx(AutopayDescription, Object.assign({ "data-cy": "autopay-minimum-payment-text" }, { children: getDescriptionText(product) })))] }) })) })) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: isChecked && (_jsxs(_Fragment, { children: [_jsx(Stack, {}), _jsx(AutopayLegal, { billing: billing, featureFlags: featureFlags, heading: t('legal.autopayTermsAndConditions'), product: product })] })) }))] }) }))] }));
};
export default OneClickAutopayBanner;
